export default __webpack_public_path__ + "static/media/ZingProjectH4.6d3c1da9.png";